import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from "axios";
import Container from 'react-bootstrap/Container';
import { Server_URL } from "../config.js";
import { GoTopBtn } from '../components/GoTopBtn';
import './ListingProducts.css';

function ListingTouchs() {
  const [touchs, setTouchs] = useState([]);
  const [deleted, setDeleted] = useState(true)
  const [keyin, setKeyin] = useState([]);
  const PdfDrawing = 'TouchDrawing,';
  const PdfSpec = 'TouchSpec,';
  const navigate = useNavigate();
  // const { id } = useParams();

  // console.log('into ListingTouchs()');
  useEffect(() => {
    if (deleted) {
      console.log('into ListingTouchs() ', `${Server_URL}/get_touchs_size/All`);
      setDeleted(false)
      axios
        .get(`${Server_URL}/get_touchs_size/All`)
        .then((res) => { setTouchs(res.data) })
        .catch((err) => console.log(err))
    }
  }, [deleted])

  return (
    // <div className='container-fluid bg-primary vh-100 vw-100'>
    // <div className='container-fluid'>
    <Container fluid className='listingtouch'>
      {/* <br /> */}
      <div> <h2 className='text-center'>Touch Panel List</h2> </div>
      {/* <div> <h1 className='listingtouch'> </h1> </div> */}
      <div className='d-flex justify-content-center'>
        <label className='p-1 fs-5'><b>Size : </b></label>
        <input type="text20" placeholder=" eg. 9.0, 21.5..." value={keyin} onChange={(e) => setKeyin(e.target.value)} />
        <Link to={`/ListingTouchsBySize/${keyin}`} className='btn btn-success mx-2 fs-5'>Select Touch Size</Link>
        <button className='btn btn-success fs-5' onClick={() => navigate(-1)}>Back</button>
        {/* <Link to='/ListingSensors' className='btn btn-success mx-2'>Add Sensor</Link> */}
        {/* <button className='btn trbtn-success' onClick={() => navigate(`/ShowSensorsSize/${keyin}`)}>Sensor Size</button> */}
      </div>
      <br />
      <h3 className='text-center'>Touch Panel All</h3>
      {/* <table className='table table-bordered vw-100'> */}
      <table>
        {/* <thead className='m-1 px-1 fs-6 text-center bg-success-subtle'> */}
        <thead className='fs-6 text-center bg-success-subtle'>
          <tr>
            <th>SNo</th> <th>Size</th> <th>-PartNo-</th> <th>Ratio</th>
            <th>-CoverOD-</th> <th>-CoverVA-</th> <th>CGThick</th>
            <th>-SensorOD-</th> <th>-SensorAA-</th> <th>SGThick</th>
            <th>ChnRxTx</th> <th>CtrlCard/IC</th>
            <th>RegDate</th> <th>Draw</th>
            <th>-Actions-</th>
          </tr>
        </thead>

        <tbody className='text-center bg-primary-subtle'> {
          touchs.map((touch, i) => {
            // console.log(" touch.SNo :", touch.SNo, " touch.PartNo :", touch.PartNo);
            return (
              <tr key={i++} className={(i % 2) ? "bg-success-primary" : 'bg-light'}>
                <td>{touch.SNo}</td> <td>{touch.Size}</td> <td>{touch.PartNo}</td> <td>{touch.Ratio}</td>
                <td>{touch.CoverOD}</td> <td>{touch.CoverVA}</td> <td>{touch.CoverThick}</td>
                <td>{touch.SensorOD}</td> <td>{touch.SensorAA}</td> <td>{touch.SensorThick}</td>
                <td>{touch.ChannelRxTx}</td> <td>{touch.ControlIC}</td>
                <td>{touch.RegistDate}</td> <td>{touch.DrawYes}</td>
                <td>
                  <Link to={`/ShowTouchDetail/${touch.SNo}`} className='btn trbtn-success'>Read</Link>
                  <Link to={`/ViewPDF/${PdfDrawing + touch.PartNo}`} className='btn trbtn-success m-1'>Drawing</Link>
                  <Link to={`/ViewPDF/${PdfSpec + touch.PartNo}`} className='btn trbtn-success'>Spec</Link>
                </td>
              </tr>
            )
          })
        } </tbody>
      </table>
      <br />
      <div className='d-flex justify-content-center'>
        <label className='p-1 fs-5'><b>Size : </b></label>
        <input type="text20" placeholder=" eg. 7.0,  15.0..." value={keyin} onChange={(e) => setKeyin(e.target.value)} required />
        <Link to={`/ListingTouchsBySize/${keyin}`} className='btn btn-success mx-2 fs-5'>Select Touch Size</Link>
        <button className='btn btn-success fs-5' onClick={() => navigate(-1)}>Back</button>
      </div>
      <div> < GoTopBtn /> </div>
    </Container>
  )
}

export default ListingTouchs

/*
function handleDelete(id) {
  axios
    .delete(`${Server_URL}/delete_touch/${id}`)
    // .delete(`http://localhost:3022/delete_touch/${id}`)
    // .delete(`http://localhost:5000/delete_touch/${id}`)
    .then((res) => { setDeleted(true) })
    .catch((err) => console.log(err))
}
*/

// useEffect(() => {
//   if (deleted) {
//     console.log('into ListingTouchs() ', `${Server_URL}/get_touchs_size/All`);
//     setDeleted(false)
//     axios
//     // .get(`${Server_URL}/show_touchs`)
//     // .get('http://localhost:3022/show_touchs')
//     // .then((res) => { setTouchs(res.data); console.log(Touchs); })
//   }
// }, [deleted])

// <thead className='fs-6 text-center bg-success-subtle'>
//   <tr>
//     <th>SNo</th> <th>Size</th> <th>-PartNo-</th> <th>Ratio</th>
//     <th>-CoverOD-</th> <th>-CoverVA-</th> <th>CGThick</th>
//     <th>-SensorOD-</th> <th>-SensorAA-</th> <th>SGThick</th>
//     <th>ChnRxTx</th> <th>CtrlCard/IC</th>
//     <th>RegDate</th> <th>Draw</th>
//     <th>-Actions-</th>
//     {/*
//     <th>SNo</th> <th>Size</th> <th>-----PartNo-----</th> <th>Ratio</th>
//     <th>----CoverOD----</th> <th>---CoverVA---</th> <th>CGThick</th>
//     <th>----LcmAA----</th> <th>---CoverVA---</th> <th>CGThick</th>
//     <th>--SensorOD--</th> <th>--SensorAA--</th> <th>SGThick</th>
//     <th>ChnRxTx</th> <th>CtrlCard/IC</th>
//     <th>CGParam，</th> <th>SensorPN，</th> <th>ConnectorType，</th>
//     <th>ConnectorType，</th> <th>FpcType，</th>
//     <th>FWConfig，</th> <th>FWDownload，</th> <th>FWUpgrade，</th> <th>FWVersion，</th>
//     <th>Resolution，</th> <th>Original，</th> <th>TestBoard，</th> <th>TestDate，</th>
//     <th>RegistDate，</th> <th>Note</th>
//     <th>--RegDate--</th> <th>--DrawYes--</th>
//     <th>--RegDate--</th> <th>---Note---</th> <th>--DrawYes--</th>
//     <th>-----------Actions-----------</th>
//     <th>--</th>
//     */}
//   </tr>
// </thead>

// <tbody className='m-1 px-1 fs-6 text-center bg-primary-subtle'> {
//   touchs.map((touch, i) => {
//     // console.log(" touch.SNo :", touch.SNo, " touch.PartNo :", touch.PartNo);
//     return (
//       <tr key={i++} className={(i % 2) ? "bg-success-primary" : 'bg-light'}>
//         <td>{touch.SNo}</td> <td>{touch.Size}</td> <td>{touch.PartNo}</td> <td>{touch.Ratio}</td>
//         <td>{touch.CoverOD}</td> <td>{touch.CoverVA}</td> <td>{touch.CoverThick}</td>
//         <td>{touch.SensorOD}</td> <td>{touch.SensorAA}</td> <td>{touch.SensorThick}</td>
//         <td>{touch.ChannelRxTx}</td> <td>{touch.ControlIC}</td>
//         <td>{touch.RegistDate}</td> <td>{touch.DrawYes}</td>
//         {/* <td>{touch.LcmAA}</td> <td>{touch.CoverVA}</td> <td>{touch.CoverThick}</td> */}
//         {/* <td>{touch.CGParam}</td> <td>{touch.SensorPN}</td> <td>{touch.CustomerPN}</td> */}
//         {/* <td>{touch.ConnectorType}</td> <td>{touch.FpcType}</td> */}
//         {/* <td>{touch.FWConfig}</td> <td>{touch.FWDownload}</td> <td>{touch.FWUpgrade}</td> <td>{touch.FWVersion}</td> */}
//         {/* <td>{touch.Resolution}</td> <td>{touch.Original}</td> <td>{touch.TestBoard}</td> <td>{touch.TestDate}</td> */}
//         {/* <td>{touch.RegistDate}</td> <td>{touch.Note}</td> <td>{touch.DrawYes}</td> */}
//         {/* <td>{touch.Note}</td> */}
//         <td>
//           <Link to={`/ShowTouchDetail/${touch.SNo}`} className='btn trbtn-success'>Read</Link>
//           <Link to={`/ViewPDF/${PdfDrawing + touch.PartNo}`} className='btn trbtn-success m-1'>Drawing</Link>
//           <Link to={`/ViewPDF/${PdfSpec + touch.PartNo}`} className='btn trbtn-success'>Spec</Link>
//           {/* <Link to={`/ShowTouchDetail/${touch.SNo}`} className='btn trbtn-success m-1 px-2 py-1'>Read</Link> */}
//         </td>
//       </tr>
//     )
//   })
// } </tbody>
